import { useEffect, useState } from "react";

function diff(target) {
  if (!target) return null;
  const ms = new Date(target).getTime() - Date.now();
  return ms;
}

function fmt(ms) {
  const abs = Math.abs(ms);
  const s = Math.floor(abs / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  if (h > 0) return `${pad(h)}:${pad(m)}:${pad(sec)}`;
  return `${pad(m)}:${pad(sec)}`;
}

export default function Countdown({ target, label, className = "" }) {
  const [ms, setMs] = useState(diff(target));

  useEffect(() => {
    setMs(diff(target));
    const id = setInterval(() => setMs(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (ms === null) return <span className={`font-mono text-zinc-600 ${className}`}>—</span>;

  const overdue = ms < 0;
  return (
    <span
      data-testid="countdown"
      className={`font-mono tabular-nums ${
        overdue ? "text-amber-400" : "text-blue-400 countdown-glow"
      } ${className}`}
    >
      {overdue ? "beklemede " : ""}
      {fmt(ms)}
      {label ? <span className="text-zinc-500 ml-1">{label}</span> : null}
    </span>
  );
}
